'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' });

var PhotoAlbum = function PhotoAlbum(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PhotoAlbum = (0, _pure2.default)(PhotoAlbum);
PhotoAlbum.muiName = 'SvgIcon';

exports.default = PhotoAlbum;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PhotoAlbum.js
// module id = 2710
// module chunks = 0